import { useMutation, useQuery }                                           from '@apollo/client'
import { ArrowUturnLeftIcon }                                              from '@heroicons/react/24/solid'
import { useDispatch, useSelector }                                        from 'react-redux'
import { useNavigate }                                                     from 'react-router-dom'
import { Button }                                                          from '../../../components'
import { LoadingEllipsis }                                                 from '../../../components/Loaders'
import SettingsSingleElementForm                                           from '../../../components/Settings/SettingsSingleElementForm'
import { setShopCategories }                                               from '../../../features/shop/shopSlice'
import { setToasts, showToaster }                                          from '../../../features/toaster/toasterSlice'
import { CREATE_SHOP_CATEGORY, GET_SHOP_CATEGORIES, UPDATE_SHOP_CATEGORY } from '../../../graphql/shop'
import MainLayout                                                          from '../../../layouts/MainLayout'

export default function SettingsShopCategories(): JSX.Element {
  const navigate: any       = useNavigate()
  const dispatch: any       = useDispatch()
  const currentUser: any    = useSelector( ( state: any ): any => state.currentUser.user )
  const shopCategories: any = useSelector( ( state: any ): any => state.shop.categories )

  const { loading, refetch } = useQuery( GET_SHOP_CATEGORIES, {
    onCompleted: ( { shopCategories }: any ): void => dispatch( setShopCategories( shopCategories ) )
  } )

  const [ createShopCategory, { loading: creating } ] = useMutation( CREATE_SHOP_CATEGORY, {
    onCompleted: (): void => dispatchMessage( 'success', 'New shop category created!' ),
    onError:     (): void => dispatchMessage( 'error', 'Creating failed. Please try again' )
  } )

  const [ updateShopCategory, { loading: updating } ] = useMutation( UPDATE_SHOP_CATEGORY, {
    onCompleted: (): void => dispatchMessage( 'success', 'Shop category updated!' ),
    onError:     (): void => dispatchMessage( 'error', 'Update failed. Please try again' )
  } )

  const dispatchMessage: any = ( type: string, message: string ): void => {
    dispatch( setToasts( [ { id: '1', type, message } ] ) )
    dispatch( showToaster( true ) )
  }

  const handleFormSubmit: any = async ( name: string, id: string ): Promise<void> => {
    const formData: any = { name }

    if ( id.length ) {
      formData.id = id
      await updateShopCategory( { variables: { input: formData } } )
    } else {
      await createShopCategory( { variables: { input: formData } } )
    }

    await refetch()
  }

  return (
    <MainLayout>
      <div className="max-w-screen-3xl mx-auto w-full">
        <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">
          { !currentUser && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4 mt-4 w-full" /> }
          { currentUser?.admin &&
            <>
              <div className="w-24 my-4">
                <Button
                  label="Back"
                  blue
                  onClick={ (): any => navigate( -1 ) }
                  icon={ <ArrowUturnLeftIcon className="w-4 h-4" /> }
                />
              </div>

              { ( loading || creating || updating ) && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4" /> }

              { ( !loading && !creating && !updating ) &&
                <>
                  { shopCategories?.map( ( shopCategory: any, index: any ): any =>
                                           <SettingsSingleElementForm
                                             handleFormSubmit={ handleFormSubmit }
                                             item={ shopCategory }
                                             key={ index }
                                           /> ) }

                  <SettingsSingleElementForm handleFormSubmit={ handleFormSubmit } namePlaceholder="Type new category name" />
                </>
              }
            </>
          }
          { !currentUser?.admin &&
            <div className="row flex flex-col items-center w-full bg-white rounded-3xl p-3 xl:p-4">
              Access Denied!
            </div>
          }
        </div>
      </div>
    </MainLayout>
  )
}
